<template>
  <div class="template-card p-2" :class="{ 'template-card-last': isLast }">
    <div class="row">
      <div class="col-7">
        <task-card :item="template.template"></task-card>
      </div>
      <div class="col-5 text-right">
        <div class="d-flex flex-column justify-content-between h-100">
          <div class="mt-2">
            <button class="btn btn-info btn-xs mr-1" @click="$emit('edit-category', template.template)" title="Change Category">
              <i class="far fa-folder mr-1"></i>
              Category
            </button>
            <button class="btn btn-info btn-xs mr-1" @click="$emit('edit-schedule', template.template.id)">
              <div class="d-flex align-items-center">
                <i class="far fa-clock mr-1"></i>
                <span class="mr-1">Schedule</span>
                <div
                  class="badge"
                  :class="{ 'badge-secondary': !template.schedules.length, 'badge-primary': template.schedules.length }"
                >
                  <i class="far fa-clock"></i>
                  {{ template.schedules.length }}
                </div>
              </div>
            </button>
            <button class="btn btn-info btn-xs mr-1" @click="$emit('edit-availability', template.template.id)">
              <i class="far fa-folder-tree mr-1"></i>
              Availability
            </button>
            <button class="btn btn-info btn-xs" @click="$emit('remove', template.template.id)">
              <i class="far fa-trash mr-1"></i>
              Remove
            </button>
          </div>
          <div class="grid" v-if="template.availability.length">
            <div
              class="badge badge-success mr-1"
              v-for="availability in template.availability"
              :key="availability.specialOccurrenceType"
            >
              <i class="far fa-folder-tree"></i>
              <span style="font-size: 0.8rem">
                {{ availability.specialOccurrenceType.toLowerCase() === 'none' ? 'Board' : availability.specialOccurrenceType }} -
                {{ availability.sortOrder }}
              </span>
            </div>
          </div>
          <div class="grid" v-if="template.schedules.length">
            <div class="badge badge-primary mr-1" v-for="schedule in template.schedules" :key="schedule.description">
              <i class="far fa-clock"></i>
              <span style="font-size: 0.8rem">
                {{ schedule.description }}
                <span v-if="schedule.cronExpressionIsLocalTime">[LT]</span>
                <span v-else>[UTC]</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { BoardItemTemplateWithScheduleAndAvailabilityDto } from '@/apiclient/apiclient_generated';
import TaskCard from '@/components/TaskCard.vue';

@Component({
  components: { TaskCard },
})
export default class TemplateCard extends Vue {
  @Prop({ required: true }) template!: BoardItemTemplateWithScheduleAndAvailabilityDto;
  @Prop({ default: false }) isLast!: boolean;
}
</script>

<style scoped lang="scss">
.template-card {
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem !important;

  &:hover {
    background-color: #f8f9fa;
  }
}

.template-card-last {
  border-bottom: none;
}
</style>
